import { useMemo, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import type { TabItem, TabItemId, TabItems } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const useScanToPayTabs = () => {
  const { formatMessage } = useIntl();

  // ─────────────────────────────────────────────────────────────────────

  const scanAndPayTab = useMemo<TabItem>(
    () => ({
      id: 'scan-to-pay.scan-and-pay-tab',
      panelId: 'scan-to-pay.scan-and-pay-panel',
      label: formatMessage(messages.scanAndPayTitle),
    }),
    [formatMessage],
  );

  const scanOnlyTab = useMemo<TabItem>(
    () => ({
      id: 'scan-to-pay.scan-only-tab',
      panelId: 'scan-to-pay.scan-only-panel',
      label: formatMessage(messages.scanOnlyTitle),
    }),
    [formatMessage],
  );

  const tabs = useMemo<TabItems>(
    () => [scanAndPayTab, scanOnlyTab],
    [scanAndPayTab, scanOnlyTab],
  );

  const [activeTabItemId, setActiveTabItemId] = useState<TabItemId>(
    scanAndPayTab.id,
  );

  // ─────────────────────────────────────────────────────────────────────

  return {
    activeTabItemId,
    scanAndPayTab,
    scanOnlyTab,
    tabs,
    setActiveTabItemId,
  };
};

// ─── Messages ───────────────────────────────────────────────────────────────

const messages = defineMessages({
  scanAndPayTitle: {
    defaultMessage: 'Scan and Pay',
    description: 'Scan To Pay | Scan and Pay',
  },
  scanOnlyTitle: {
    defaultMessage: 'Scan Only',
    description: 'Scan To Pay | Scan Only',
  },
});
